import {
  Dashboard,
  TopMenuData,
  CategoryMaterialsData,
  UserActiveData,
  ChartData,
  ChartDataDealer,
  TableDealer,
} from '@/domain/entities/Dashboard'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class DashboardDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): Dashboard {
    const { data } = result
    //  console.log('dataaaaaaa -->', data.data.category_materials.items)
    return new Dashboard(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (val) =>
          new TopMenuData(
            val.id,
            val.name,
            val.key,
            val.value,
            val.icon,
            val.color
          )
      ),
      data.data.charts.items.map(
        (val) =>
          new ChartData(
            val.value,
            val.dealer_code,
            val.dealer_name,
            val.dealer_city
          )
      ),
      data.data.charts_dealer_unregister.items.map(
        (val) => new ChartDataDealer(val.value, val.name)
      ),
      data.data.charts_dealer_not_accessed.items.map(
        (val) => new ChartDataDealer(val.value, val.name)
      ),
      data.data.user_dealer_unregister.items.map(
        (val) =>
          new TableDealer(
            val.id,
            val.salesmancode,
            val.salesmanname,
            val.possition,
            val.last_access
          )
      ),
      data.data.user_dealer_not_accessed.items.map(
        (val) =>
          new TableDealer(
            val.id,
            val.salesmancode,
            val.salesmanname,
            val.possition,
            val.last_access
          )
      ),
      data.data.user_active.items.map(
        (val) =>
          new UserActiveData(
            val.id,
            val.dealer_code,
            val.dealer_name,
            val.dealer_city,
            val.dealer_group,
            val.total_access
          )
      ),
      data.data.category_materials.items.map(
        (val) =>
          new CategoryMaterialsData(
            val.id,
            val.title,
            val.category,
            val.total_views,
            val.total_user_accessed
          )
      )
    )
  }
}
